import * as React from 'react';

import {appHistory} from '../../../history';

import {useToggleComparison} from '../editions/a-b-testing/graphql/hooks/use-toggle-comparison';
import {NewEditionModal} from '../editions/new-edition-modal';
import {EditionMutations} from '../graphql-wrappers/edition/edition-mutations';
import {getFieldsToCompare} from '../utils';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    campaignId: string;
};

export function NewNewsletterModal(props: Props) {
    const {toggleComparison} = useToggleComparison();
    const shouldToggleComparisonRef = React.useRef(false);
    // @ts-expect-error
    let fieldsToCompare = [];

    return (
        <EditionMutations>
            {({onCreate, onDuplicate}) => (
                <NewEditionModal
                    campaignId={props.campaignId}
                    type='newsletterEditions'
                    isOpen={props.isOpen}
                    onClose={props.onClose}
                    onCreateEdition={(name, campaignId) => {
                        return onCreate(
                            name,
                            campaignId,
                            shouldToggleComparisonRef.current,
                            // @ts-expect-error
                            getFieldsToCompare(fieldsToCompare)
                        ).then((newEdition) => {
                            if (newEdition) {
                                if (shouldToggleComparisonRef.current) {
                                    appHistory.push(`${newEdition.htmlUrlPath}/a-b-test`);
                                } else {
                                    appHistory.push(newEdition.htmlUrlPath);
                                }
                            }
                        });
                    }}
                    onDuplicateEdition={(editionId: string, campaignId: string, name: string) => {
                        return onDuplicate(editionId, campaignId, name).then((newEdition) => {
                            if (newEdition) {
                                if (shouldToggleComparisonRef.current) {
                                    toggleComparison({
                                        editionId: newEdition.id,
                                        shouldBeComparison: true,
                                        // @ts-expect-error
                                        fieldsToCompare: getFieldsToCompare(fieldsToCompare),
                                    }).then(() => {
                                        appHistory.push(`${newEdition.htmlUrlPath}/a-b-test`);
                                    });
                                    appHistory.push(`${newEdition.htmlUrlPath}/a-b-test`);
                                } else {
                                    appHistory.push(newEdition.htmlUrlPath);
                                }
                            }
                        });
                    }}
                    toggleComparison={(fields) => {
                        shouldToggleComparisonRef.current = true;
                        fieldsToCompare = fields;
                    }}
                />
            )}
        </EditionMutations>
    );
}
